import { faBackwardStep } from "@fortawesome/free-solid-svg-icons/faBackwardStep";
import { faForwardFast } from "@fortawesome/free-solid-svg-icons/faForwardFast";
import { faForwardStep } from "@fortawesome/free-solid-svg-icons/faForwardStep";
import { faPlay } from "@fortawesome/free-solid-svg-icons/faPlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICampanhaDesconto } from "app/types/CupomDesconto/ICampanhaDesconto";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useState } from "react";
const estiloDetalhamentoCampanhaDeDesconto = require("./DetalhamentoCampanhaDeDesconto.module.scss").default;

export type DetalhamentoCampanhaDeDescontoProps = {
  campanha: ICampanhaDesconto;
  onFechar: () => void;
  onIrPrimeiraPagina: () => void;
  onVoltarPagina: () => void;
  onProximaPagina: () => void;
  onUltimaPagina: () => void;
  paginaAtual: number;
  totalPagina: number;
};

const DetalhamentoCampanhaDeDesconto = (props: DetalhamentoCampanhaDeDescontoProps) => {
  const abas = ["Produtos", "Filiais"];
  const [abaSelecionada, setAbaSelecionada] = useState(abas[0]);
  return (
    <>  
      <div className="_flex _mb-4 _gap-8">
        <div>Campanha: <input type="text" value={(props.campanha.Campanha) ?? ""} readOnly disabled></input></div>
        <div>Validade: <input type="text" value={`${globalMU.formatJsonDate(props.campanha.ValidadeInicial)} a ${globalMU.formatJsonDate(props.campanha.ValidadeFinal)}`} readOnly disabled></input></div>
      </div>
      <div className="_flex _mb-4 _gap-8">
        <button disabled={props.paginaAtual > 1 ? false : true} onClick={props.onIrPrimeiraPagina} className={clsx(estiloDetalhamentoCampanhaDeDesconto.botaoIcone,'no-global-button')} ><FontAwesomeIcon icon={faBackwardStep}  /></button>
          <button disabled={props.paginaAtual > 1 ? false : true} onClick={props.onVoltarPagina} className={clsx(estiloDetalhamentoCampanhaDeDesconto.botaoIcone,'no-global-button')}><FontAwesomeIcon icon={faPlay} className="_transform _rotate-180" /></button>
          <button disabled={props.paginaAtual < props.totalPagina ? false : true} onClick={props.onProximaPagina} className={clsx(estiloDetalhamentoCampanhaDeDesconto.botaoIcone,'no-global-button')}><FontAwesomeIcon icon={faPlay}/></button>
          <button disabled={props.paginaAtual < props.totalPagina ? false : true} onClick={props.onUltimaPagina} className={clsx(estiloDetalhamentoCampanhaDeDesconto.botaoIcone,'no-global-button')}><FontAwesomeIcon icon={faForwardStep}/></button>
        <div className="_flex _p-2 _gap-8">
         <div>Vr. Mín. Venda: <input type="text" className="_text-right" value={(globalMU.formatarValorNumerico(props.campanha.ValorMinimoVenda,2,false)) ?? ""} readOnly disabled></input></div>
         <div>Vr. Desconto: <input type="text" className="_text-right" value={(globalMU.formatarValorNumerico(props.campanha.Valor,2,false)) ?? ""} readOnly disabled></input></div>
       </div>
      </div>

      <div className="_flex _border-b">
        {abas.map((aba) => (
          <div
            key={aba}
            className={clsx(
              aba == abaSelecionada
                ? estiloDetalhamentoCampanhaDeDesconto.abaSelecionada
                : "",
                estiloDetalhamentoCampanhaDeDesconto.aba
            )}
            onClick={() => {
              setAbaSelecionada(aba);
            }}
          >
            {aba}
          </div>
        ))}
      </div>


      {abaSelecionada == "Produtos" && (
      <div id="tabela-campanhas-desconto-disponiveis" className={estiloDetalhamentoCampanhaDeDesconto.tabela}>
          <div>
            <div style={{flexBasis: "10%"}}>Código</div>
            <div style={{flexBasis: "30%"}}>Referência</div>
            <div style={{flexBasis: "60%"}}>Descrição</div>
          </div>
          {props.campanha.Produtos?.map((produto) => {
              return (
              <div >
                <div style={{flexBasis: "10%"}}>{produto.CodigoProduto}</div>
                <div style={{flexBasis: "30%"}}>{produto.Referencia}</div>
                <div style={{flexBasis: "60%"}}>{produto.Descricao}</div>
              </div>
            )})}
      </div>)}

     {abaSelecionada == "Filiais" && (
     <div id="tabela-campanhas-desconto-disponiveis" className={estiloDetalhamentoCampanhaDeDesconto.tabela}>
        <div>
          <div style={{flexBasis: "10%"}}>Código</div>
          <div style={{flexBasis: "90%"}}>Filial</div>
        </div>
        {props.campanha.Filiais?.map((filial) => {
            return (
            <div key={filial.CodigoFilial}>
              <div style={{flexBasis: "10%"}}>{filial.CodigoFilial}</div>
              <div style={{flexBasis: "90%"}}>{filial.NomeFilial}</div>
            </div>
          )})}
     </div>)}

     <div className="_flex _justify-between _mt-4">
       
       
       
       <div className="_flex _p-2 _gap-4">
          <button onClick={props.onFechar} >Fechar</button>
       </div>
     </div>
    </>
  );
};

export { DetalhamentoCampanhaDeDesconto };